import 'jquery-nice-select';
const handler = ( $ ) => {
	const itemsPerLoad = 1;
	$( document ).ready( function () {
		const $container = $( '.case-studies-container' );
		$( '.case-studies-container > .category-group' ).each( function ( i ) {
			if ( ! $( this ).hasClass( 'animate-in' ) ) {
				$( this ).addClass( 'hide' );
			}


			$( this )
				.find( ' > .row' )
				.each( function ( j ) {
					if ( j >= itemsPerLoad ) {
						$( this ).addClass( 'hide' );
					} else {
						const directionClass =
							j % 2 === 0
								? 'slide-right-init'
								: 'slide-left-init';
						$( this ).addClass( directionClass );
						const delay = 50 * j;

						setTimeout( () => {
							$( this )
								.addClass( 'animate-in show' )
								.removeClass(
									'slide-left-init slide-right-init'
								)
								.css( 'pointer-events', 'auto' );
						}, delay );
					}
				} );

		} );

		if ( $( '.case-studies-container > .row' ).length > 0 ) {
			$( '.case-studies-container > .row' ).each( function ( i ) {
				const elementTop = $( '.case-studies-container' ).offset().top;
				const windowBottom =
					$( window ).scrollTop() + $( window ).height();
				let itemsToShow = 1;
				if ( elementTop > windowBottom ) {
					itemsToShow = 0;
				}
				if ( i >= itemsToShow ) {
					$( this ).addClass( 'hide' );
				} else {
					const directionClass =
						i % 2 === 0 ? 'slide-right-init' : 'slide-left-init';
					$( this ).addClass( directionClass );
					const delay = 50 * i;

					setTimeout( () => {
						$( this )
							.addClass( 'animate-in show' )
							.removeClass( 'slide-left-init slide-right-init' )
							.css( 'pointer-events', 'auto' );
					}, delay );
				}
			} );

		}

		let lastIndex = $( '.categories-filter .category' ).index(
			$( '.categories-filter .category.active' )
		);

		$( '.categories-filter .category' ).on( 'click keydown', function () {
			if ( event.type === 'click' || event.key === 'Enter' ) {
				const $parent = $( this ).closest( '.category' );
				const currentIndex = $( '.categories-filter .category' ).index(
					$parent
				);
				const selectedId = $( this ).data( 'id' );

				// 1. Determine direction class
				const directionClass =
					currentIndex > lastIndex
						? 'slide-left-init'
						: 'slide-right-init';

				lastIndex = currentIndex;

				if ( selectedId === 'all' ) {
					history.pushState( null, null, window.location.pathname + window.location.search );
				} else {
					history.pushState( null, null, '#' + selectedId );
				}

				$( '.category-group' ).each( function () {
					const $group = $( this );
					const groupCategory = $group.data( 'category' );
					if ( groupCategory == selectedId ) {
						$group.removeClass(
							'hide slide-left-init slide-right-init animate-in'
						);

						$group.addClass( directionClass ).show();
						void $group[ 0 ].offsetWidth;
						$group
							.addClass( 'animate-in' )
							.removeClass( directionClass );
					} else {
						$group.addClass( 'hide' ).removeClass( 'animate-in' );
					}
				} );
			}
		} );

		lastIndex = 0;
		$( document ).on(
			'click keydown',
			'.search-form .nice-select .option',
			function () {
				if ( event.type === 'click' || event.key === 'Enter' ) {
					const $clickedOption = $( this );
					const currentIndex = $clickedOption.index();

					// Find the corresponding data-id from the hidden native select
					const $nativeOption = $( '#mobile-choice option' ).eq(
						currentIndex
					);
					const selectedId = $nativeOption.data( 'id' );

					const directionClass =
						currentIndex > lastIndex
							? 'slide-left-init'
							: 'slide-right-init';

					lastIndex = currentIndex;

					if ( selectedId === 'all' ) {
						history.pushState( null, null, window.location.pathname + window.location.search );
					} else {
						history.pushState( null, null, '#' + selectedId );
					}

					$( '.category-group' ).each( function () {
						const $group = $( this );
						const groupCategory = $group.data( 'category' );

						// Handle the "All projects" logic
						if (
							selectedId === 'all' ||
							groupCategory == selectedId
						) {
							$group.removeClass(
								'hide slide-left-init slide-right-init animate-in'
							);
							$group.addClass( directionClass ).show();

							void $group[ 0 ].offsetWidth;

							$group
								.addClass( 'animate-in' )
								.removeClass( directionClass );
						} else {
							$group
								.addClass( 'hide' )
								.removeClass( 'animate-in' );
						}
					} );
				}
			}
		);
		$( document ).ready( function () {
			const $underline = $( '.moving-underline' );
			const $navItems = $( '.categories-filter .category' );

			function moveUnderline( $element ) {
				if ( ! $element.length ) return;

				const width = $element.outerWidth();
				const left = $element.position().left;

				$underline.css( {
					width: width + 'px',
					transform: `translateX(${ left }px)`,
				} );
			}

			moveUnderline( $( '.categories-filter .category.active' ) );
			$navItems.on( 'click keydown', function () {
				if (event.type === 'click' || event.key === 'Enter') {
					const $this = $( this );
					$navItems.removeClass( 'active' );
					$this.addClass( 'active' );

					moveUnderline( $this );
				}
			} );
		} );

		$( window ).on( 'scroll', function () {
			checkAndReveal();
		} );

		// Trigger on load and resize to catch items already in view
		$( window ).on( 'load resize', function () {
			checkAndReveal();
		} );

		function checkAndReveal() {
			if ( $container.length > 0 ) {
				const $parentGroup = $container.find(
					'.category-group.animate-in'
				);
				let $firstHiddenRow = $parentGroup.find( '.row.hide' ).first();

				if ( $firstHiddenRow.length == 0 ) {
					$firstHiddenRow = $container.find( '.row.hide' ).first();
				}

				if ( $firstHiddenRow.length > 0 ) {
					const scrollBottom =
						$( window ).scrollTop() + $( window ).height();
					const hiddenRowTop = $firstHiddenRow.offset().top + 200;

					// If the hidden row is above the bottom of the screen, reveal it
					if ( hiddenRowTop > 0 && scrollBottom > hiddenRowTop ) {
						revealNextRows();
					}
				}
			}
		}

		$( '#mobile-choice' ).niceSelect();

		function applyHashFilter( slug ) {
			const $filterItems = $( '.categories-filter .category' );
			const isAll = ! slug;
			const $target = isAll
				? $filterItems.filter( '[data-id="all"]' )
				: $filterItems.filter( '[data-id="' + slug + '"]' );

			if ( ! $target.length ) return;

			const currentIndex = $filterItems.index( $target );
			const directionClass = currentIndex > lastIndex ? 'slide-left-init' : 'slide-right-init';
			lastIndex = currentIndex;

			$filterItems.removeClass( 'active' );
			$target.addClass( 'active' );

			const $underline = $( '.moving-underline' );
			$underline.css( {
				width: $target.outerWidth() + 'px',
				transform: 'translateX(' + $target.position().left + 'px)',
			} );

			$( '.category-group' ).each( function () {
				const $group = $( this );
				const groupCategory = $group.data( 'category' );
				if ( isAll ? groupCategory === 'all' : groupCategory == slug ) {
					$group.removeClass( 'hide slide-left-init slide-right-init animate-in' );
					$group.addClass( directionClass ).show();
					void $group[ 0 ].offsetWidth;
					$group.addClass( 'animate-in' ).removeClass( directionClass );
				} else {
					$group.addClass( 'hide' ).removeClass( 'animate-in' );
				}
			} );
		}

		applyHashFilter( window.location.hash.replace( '#', '' ) );

		$( window ).on( 'hashchange', function () {
			applyHashFilter( window.location.hash.replace( '#', '' ) );
		} );

		let isRevealing = false;

		function revealNextRows() {
			if ( isRevealing ) return;

			let $toShow = $( '.category-group.animate-in > .row.hide' );

			if ( $toShow.length == 0 ) {
				$toShow = $( '.case-studies-container > .row.hide' );
			}

			if ( $toShow.length > 0 ) {
				isRevealing = true;

				const $row = $toShow.first();
				const indexItem = $row.index();

				$row.removeClass( 'hide' ).show();

				const directionClass =
					indexItem % 2 === 0
						? 'slide-right-init'
						: 'slide-left-init';
				$row.addClass( directionClass );

				setTimeout( () => {
					$row.addClass( 'animate-in show' )
						.removeClass( 'slide-left-init slide-right-init' )
						.css( 'pointer-events', 'auto' );

					isRevealing = false;

					checkAndReveal();
				}, 50 );
			}
		}

		$( window ).on( 'scroll resize', function () {
			if ( $( window ).width() > 991 ) {
				$( '.case-study-section--two-cols' ).each( function () {
					const $section = $( this );
					const $asideContainer = $section.find(
						'.case-study-section__aside'
					);
					const $stickyContent = $section.find(
						'.case-study-section__aside-content'
					);

					const scrollTop = $( window ).scrollTop();
					const sectionTop = $section.offset().top;
					const sectionHeight = $section.innerHeight();
					const stickyHeight = $stickyContent.outerHeight();
					const parentWidth = $asideContainer.width();

					const stopPoint = sectionTop + sectionHeight - stickyHeight;
					if ( scrollTop > sectionTop && scrollTop < stopPoint ) {
						$stickyContent
							.addClass( 'is-fixed' )
							.removeClass( 'is-absolute' )
							.css( 'width', parentWidth + 'px' );
					} else if ( scrollTop >= stopPoint ) {
						$stickyContent
							.addClass( 'is-absolute' )
							.removeClass( 'is-fixed' )
							.css( 'width', parentWidth + 'px' );
					} else {
						$stickyContent
							.removeClass( 'is-fixed is-absolute' )
							.css( 'width', 'auto' );
					}
				} );
			}
		} );
	} );
};
export default ( ( $ ) => $( handler ) )( jQuery );
